module.exports = __webpack_public_path__ + "static/media/fanghuomen.75b9ba1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/fanghuomen.mp3
// module id = 9XcA
// module chunks = 208